import React, { useState, useEffect } from "react";
import { PlatformSectionContents } from "./data";

const PlatformSection = () => {
  return (
    <div
      style={{
        background: 'url("/static/img/platform-background.png")',
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
      className="overflow-hidden pb-0 md:pb-10 pt-10 relative before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-1/2 before:bg-gradient-to-b before:from-[#0C0F14] before:to-transparent after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-10 after:bg-gradient-to-t after:from-[#0C0F14] after:to-transparent"
    >
      <div className="container mx-auto px-4 md:px-10 flex flex-col justify-between">
        <div className="text-white relative mb-5 flex flex-col gap-4  lg:flex-row items-start justify-between">
          <div className="flex-1">
            <div className="text-[32px] md:text-[42px] lg:text-[52px] xl:text-[62px] font-bold mb-5 leading-snug">
              Mastery in Data Discovery and Visualization
            </div>
            <div className="text-[18px] md:text-[20px] lg:text-[22px] xl:text-[24px] font-normal mb-10">
              {/* Rose AI is an intuitive platform designed for financial analysts
              and decision-makers, providing a robust data solution experience. */}
              Rose AI integrates advanced language models to offer a seamless
              journey from data discovery to insightful visualizations, ensuring
              every data point is explainable and traceable.
            </div>
          </div>
          <div className="flex-1">
            <img
              src="/static/img/platform-equity-returns.png"
              alt="equity returns"
              className="block"
            />
          </div>
        </div>
        <div className="flex w-full text-white flex-col md:flex-row">
          {PlatformSectionContents.map((qa, index) => (
            <div
              key={index}
              className="pl-2 pr-2 py-3 my-3 max-w-xl border-l-4 border-l-transparent transition-all hover:border-l-primary"
            >
              <div className="text-[20px] lg:text-[22px] font-bold mb-3">
                {qa.title}
              </div>
              <div className="text-[18px] lg:text-[20px]">{qa.text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlatformSection;
